import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Site, SiteType } from '@iot-platform/models/i4b';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailPopupDisplayPropertyComponent } from '../../detail-popup/detail-popup-display-property/detail-popup-display-property.component';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, DetailPopupDisplayPropertyComponent, InfoDisplayPipe],
  selector: 'iot-platform-ui-site-detail-basic-info',
  templateUrl: './site-detail-basic-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./site-detail-basic-info.component.scss']
})
export class SiteDetailBasicInfoComponent {
  site = input<Site | null>(null);
  displayMode = input<'vertical' | 'horizontal' | 'default'>('default');

  selectSite = output<Site>();

  protected readonly SiteType = SiteType;
}
